<template>
  <div id="contact">
    <h2>お問い合わせ</h2>
    <Contactform></Contactform>
  </div>
</template>
<script>
import Contactform from "@/components/PartForm.vue";
export default {
  setup() {},
  data() {},
  components: {
    Contactform,
  },
};
</script>
<style lang="scss" scoped>
#contact {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 $h-gap;
  box-sizing: content-box;
  h2 {
    font-weight: bold;
    color: $color_blue;
    font-size: 2rem;
    padding-top: calc($v-gap/2);
    margin-bottom: 1em;
    position: relative;
    padding-bottom: 0.5em;
    &::after {
      content: "";
      display: block;
      height: 4px;
      width: 3em;
      bottom: 0;
      position: absolute;
      background-color: $color_blue;
    }
  }
}
</style>
